export default __webpack_public_path__ + "static/media/1603.3f7d7ad5.png";